<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`油气费汇总表`)">导出</el-button>
        </el-form-item>

        <!-- 全部记录 -->
        <el-form-item>
          <el-button class="allRecord" type="primary" @click="goAllRecord">全部记录</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"></Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'oil',
      getListUrl: 'summarylist',
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.fleet,
        },
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "license", label: "车牌号" },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "doil_count", label: "加油单量", align: 'right', className: 'pr30' },
        { keyName: "doil", label: "加油金额", align: 'right', className: 'pr30' },
      ],
      getTotalProperty: [
        'doil_count',
        'doil',
        'moneydoil',
        'summary_doil'
      ],
      btns: [
        {
          class: 'viewlistbtn',
          title: '查看列表',
          img: require('@/assets/img/icon_car_view.png'),
          unimg: require('@/assets/img/icon_car_view_hover.png'),
          cb: ({ month, license }) => {
            this.$router.push({
              path: `/finance/oilFee/cashorder`,
              query: {
                license,
                month,
                gsid: 1,
              }
            })
          },
        },
      ],
      baseParams: [
        'gsid',
        'month',
      ],
    };
  },
  methods: {
    goAllRecord() {
      this.$router.push({
        path: `/finance/oilFee/cashorderall`,
        query: {
          month: this.formInline.month,
          gsid: this.formInline.gsid,
        }
      })
    },
  },
  created() { },
  mounted() {
    this.getFleet()
    // 定点加油配置id，固定不变
    this.$set(this.formInline, 'gsid', 1)
    this.$set(this.formInline, 'month', this.CURR_MONTH)
    this.MONTH = this.CURR_MONTH
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped></style>
